

















































import { defineComponent, computed, reactive, getCurrentInstance } from '@vue/composition-api';
import { DialogPlugin } from 'tdesign-vue';
import linkList from '@/renderer/components/linkList/index.vue';
import i18n, { i18n_t } from '@/locales/i18n';
import store from '@/renderer/store/index';
import tips, { MsgError } from '@/renderer/scripts/utils/tips';
import smh, { SMH } from '@/renderer/scripts/smh';
import ipc from '@/renderer/scripts/utils/ipc';
import CustomDialog from '@/renderer/scripts/utils/CustomDialog';

export default defineComponent({
  components: {
    linkList,
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const shareSwitch = computed(() => store.getters.enableShare);
    const linkQueryParams = reactive<SMH.OrgShareListParams>({
      name: '',
      expireTimeRange: [],
      userFilter: '',
    });
    const methods = {
      async switchChange() {
        const headerMsg = shareSwitch.value ? i18n_t('确定关闭吗？') : i18n_t('是否开启外链功能？');
        const bodyMsg = shareSwitch.value
          ? i18n_t('关闭外链功能后，已有外链将失效，且无法创建外链')
          : i18n_t('开启后，所有拥有外链分享权限的用户均可创建外链');
        const tipsMsg = shareSwitch.value ? i18n_t('关闭成功') : i18n_t('开启成功');
        const commitValue = !shareSwitch.value;
        const dialog = CustomDialog.confirm({
          header: headerMsg,
          body: bodyMsg,
          theme: 'warning',
          onConfirm: async () => {
            if (dialog.hide) {
              dialog.hide();
            }
            try {
              await smh.userAPI.updateOrgInfo({
                name: store.getters.orgName,
                extensionData: {
                  enableShare: commitValue,
                },
              });
              store.commit('SET_ENABLE_SHARE', commitValue);
              tips.success(tipsMsg);
            } catch (error) {
              tips.error(error as MsgError);
            }
          },
          onCancel: () => {
            if (dialog.hide) {
              dialog.hide();
            }
          },
        });
      },
      linkConditionQuery() {
        ipc.emit(ipc.RENDERER_EVENTS_MAP.LINK_LIST_FRESH);
      },
      linkConditionReset() {
        linkQueryParams.name = '';
        linkQueryParams.expireTimeRange = [];
        linkQueryParams.userFilter = '';
      },
    };
    return {
      shareSwitch,
      linkQueryParams,
      ...methods,
    };
  },
});
